<template>
<v-container  grid-list-md fluid>
  <v-layout row wrap>
    <v-flex md12>
      <v-card>
        <v-toolbar dense primary-title class="py-0">
          <v-toolbar-title>{{$t('view.monitorCorreos.filtros.label')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
            <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
          <v-card-text v-show="view.elem.showForm">
            <v-form role="form" align-center justify-center>
              <v-layout   v-if="!view.action.submit.busy" >
                <v-radio-group row
                :error-messages="$t(`validator.${getFirstError($v.monitorCorreos.estatus)}.text`,'')" 
                v-model="view.elem.input.radio.estatus.selectedEstatus"  
                @change="search">
                
                  <v-flex md3 sm6 xs6 >
                    <v-radio class="text-xs-center" 
                    :label="$t('view.monitorCorreos.estatus.options.todos.label')" 
                    value="pendiente,enviado,error">
                    </v-radio>
                  </v-flex>
                  <v-flex md3 sm6 xs6 class="text-xs-center">
                    <v-radio 
                    :label="$t('view.monitorCorreos.estatus.options.pendiente.label')" 
                    
                    value="pendiente">
                    </v-radio>
                  </v-flex>
                  <v-flex md3 sm6 xs6 class="text-xs-center">
                    <v-radio 
                    :label="$t('view.monitorCorreos.estatus.options.enviado.label')" 
                    
                    value="enviado">
                    </v-radio>
                  </v-flex>
                  <v-flex md3 sm6 xs6 class="text-xs-center">
                    <v-radio 
                    :label="$t('view.monitorCorreos.estatus.options.error.label')" 
                    
                    value="error">
                    </v-radio>
                  </v-flex>
                
                </v-radio-group>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
  </v-layout>
  <data-table ref="tableMonitorCorreos"></data-table>
</v-container>
</template>
<script>
import {MonitorCorreosModel} from "@/models/bitacoras/monitor-correos";
import {required} from "vuelidate/lib/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import DataTable from "@/views/bitacoras/monitorCorreos/DataTable";
import tippy from 'tippy.js';
import * as states from "@/views/bitacoras/monitorCorreos/monitor-correos-states";
import * as R from "ramda";
//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
  }
};

const input = {
  radio:{
    estatus:
    {
      selectedEstatus: 'pendiente,enviado,error'
    }
  }
}
//Action's state
const action = {
  submit:{
    busy:false
  }
};

//Initial Model
//const monitorCorreos = new MonitorCorreosModel();
//Helpers
function evaluateModelChangedMethodResult(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((model)=>R.compose(evaluateModelChangedFlag,model.changed));

export default {
  name: "MonitorCorreoss",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , date: undefined
      , monitorCorreos : undefined
      , state : new Object()
      , view:{
        title:"Monitor de notificaciones"
        , action
        , elem:{
          button
          , input
          , showForm: true
        }
      }
      , check:true
    };
  }
  ,methods: {
    ...allValidatorMethods
    , async search(){
      try{
        this.$refs.tableMonitorCorreos.refreshData();
      }catch(error){
      }
    }
  }
  , computed:{
   
  }
  , validations:{
    monitorCorreos:{
      estatus:{
        required:false
      }
    }
  }
  , components: {
    VueContentLoading
    , DataTable
  }
  // Instance Lifecycle Hooks
  , async created(){
    Object.setPrototypeOf(this.state, new states.InitialState(this));
    try {
      clearInterval(monitorCorreosDatatableRefresh);
    } catch(error){}
    //Set Time Interval
    const monitorCorreosDatatableRefresh = setInterval(() => {  
      this.search();
    }, 1000 * 10);
  }
  , beforeMount(){
  }
  , mounted(){
    this.$v.$reset();
    // this.$parent.appJQueryConfigMethod();
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bitacoras/monitorCorreos/MonitorCorreos.vue